import React from 'react';

import { TextButton } from '@candu-ai/craft/ui';
import { DropdownBox } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { CommonNodeProperties, MediaBreakpoint as Breakpoints } from 'craft/types';

interface Props {
  nodeIds: string[];
}

const columnLayouts = [
  {
    breakpoint: Breakpoints.LG,
    options: [{ name: '1 Row (12 x 1)', value: 1 }],
    label: 'Desktop',
    defaultValue: 1,
  },
  {
    breakpoint: Breakpoints.MD,
    options: [
      { name: '1 Row (12 x 1)', value: 1 },
      { name: '2 Rows (6 x 2)', value: 2 },
      { name: '3 Rows (4 x 3)', value: 3 },
      { name: '6 Rows (2 x 6)', value: 6 },
    ],
    label: 'Medium device',
    defaultValue: 1,
  },

  {
    breakpoint: Breakpoints.SM,
    options: [
      { name: '1 Row (12 x 1)', value: 1 },
      { name: '2 Rows (6 x 2)', value: 2 },
      { name: '3 Rows (4 x 3)', value: 3 },
      { name: '6 Rows (2 x 6)', value: 6 },
    ],
    label: 'Small device',
    defaultValue: 1,
  },
];

export const GridColumn = ({ nodeIds }: Props) => {
  const {
    media,
    actions: { setCustom },
  } = useMultiNodes(
    nodeIds,
    (node) => ({
      media: node?.data.custom?.media ?? {},
    }),
    CommonNodeProperties.Multiple,
  );

  const onChange = (selectedValue: Record<string, number>) => {
    setCustom({
      media: {
        ...media,
        columns: { ...media.columns, ...selectedValue },
      },
    });
  };

  const onReset = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { columns, ...otherCustomProps } = media;
    setCustom({
      media: otherCustomProps,
    });
  };

  return (
    <div data-cy="column-choice-container">
      {columnLayouts.map((columnLayout) => {
        const changeLayout = (selectedValue: number) => {
          onChange({ [columnLayout.breakpoint]: selectedValue });
        };
        return (
          <DropdownBox
            key={columnLayout.breakpoint}
            value={media.columns?.[columnLayout.breakpoint] || columnLayout.defaultValue}
            onChange={changeLayout}
            options={columnLayout.options}
            label={columnLayout.label}
          />
        );
      })}
      <TextButton onClick={onReset}>Reset</TextButton>
    </div>
  );
};
